<template>
  <header class="site-header">
    <div class="container nav-inner">
      <div class="brand">
        <router-link to="/" class="logo">
          <img :src="icon" alt="Noun Rush" />
          <span class="title">Noun Rush</span>
        </router-link>
      </div>
      <nav class="main-nav">
        <router-link to="/">Home</router-link>
        <router-link to="/terms">Terms</router-link>
        <router-link to="/privacy">Privacy</router-link>
        <a class="play-btn" href="https://play.google.com/store/apps/details?id=com.southsidegamez.WordRouletteOnline" target="_blank" rel="noopener">
          <img :src="playBadge" alt="Get it on Google Play">
        </a>
      </nav>
    </div>
  </header>

  <main>
    <router-view />
  </main>

  <footer class="site-footer">
    <div class="container footer-inner">
      <div>
        <strong>Kevex Solutions</strong>
        <div class="muted">Creator of Noun Rush</div>
      </div>
      <div class="copyright">© 2026 Kevex Solutions</div>
    </div>
  </footer>
</template>

<script setup>
import icon from '@/assets/noun rush icon 512 512.png'
import playBadge from '@/assets/play-badge.svg'
</script>

<style lang="scss">
:root{
  --bg: #071226;
  --card: #071a2a;
  --muted: #9aa4b2;
  --accent: #42b983;
}
*{box-sizing:border-box}
html{font-size:clamp(14px,1.2vw,18px)}
body{margin:0;font-family:Inter,system-ui,Segoe UI,Roboto,Arial;background:var(--bg);color:#eaf4ff;line-height:1.6}
.container{max-width:1100px;margin:0 auto;padding:0 1rem}
.site-header{border-bottom:1px solid rgba(255,255,255,0.03);padding:14px 0}
.nav-inner{display:flex;align-items:center;justify-content:space-between}
.brand .logo{display:flex;align-items:center;gap:12px;text-decoration:none;color:inherit}
.brand img{width:clamp(40px,6vw,64px);height:auto;border-radius:10px}
.title{font-weight:700}
.main-nav{display:flex;align-items:center;gap:14px}
.main-nav a{color:var(--muted);text-decoration:none;padding:6px 8px;border-radius:6px}
.main-nav a:focus-visible{outline:3px solid rgba(66,185,131,0.18);outline-offset:2px}
.main-nav a.router-link-exact-active{color:var(--accent)}
.play-btn img{height:clamp(36px,6vw,56px)}
main{padding:28px 0}
.site-footer{border-top:1px solid rgba(255,255,255,0.03);padding:18px 0}
.footer-inner{display:flex;justify-content:space-between;align-items:center}
.muted{color:var(--muted);font-size:0.9rem}
.copyright{color:var(--muted)}

@media (max-width:1024px){
  .container{padding:0 1rem}
}

@media (max-width:760px){
  .nav-inner{flex-direction:column;align-items:flex-start;gap:12px}
  .main-nav{flex-wrap:wrap}
  .footer-inner{flex-direction:column;align-items:flex-start;gap:8px}
}
</style>
